module.exports = __webpack_public_path__ + "img/papel-toalha.24aabef0.png";